import React, { useEffect, useState } from "react";
import { GetAllTasksToEvalAssigin } from "../../Redux/Reducers/TasksManager";
import { useDispatch, useSelector } from "react-redux";
import { GetAccountUserAssigning } from "../../Redux/Reducers/AccountUserAssignin";
import AllDropDownsAHSF from "../../Components/AllDropDownsAHSF";
import { CreateSubTaskeByFlowAndUser } from "../../Redux/Reducers/SubTaskFlow";
import LoaderAHSF from "../../Components/LoaderAHSF";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ButtonAHSF from "../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./style.css";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
const AssiginToEvaluters = (props) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      AccountUserAssigning: state.AccountUserAssigning.AccountUserAssigning,
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      TaskEvaluterAssigin: state.TasksManager.TaskEvaluterAssigin,
      loadingTaskEvaluterAssigin: state.TasksManager.loadingTaskEvaluterAssigin,
      UserInfo: state.UserInfo.UserInfo,
      refreshTableStatus: state.refreshTableStatus.refreshTable,
    };
  });
  const [tasksList, settasksList] = useState([]);
  const [userList, setuserList] = useState([]);
  const [evalName, setevalName] = useState("");
  const [AppNumberList, setAppNumberList] = useState([]);
  const [loading, setloading] = useState(true);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  //   const itemsPerPage = 1; // عدد العناصر في كل صفحة
  const [currentPage, setCurrentPage] = useState(1); // الصفحة الحالية
  const [selectAll, setSelectAll] = useState(false); // تحديد الكل
  // حساب بداية ونهاية العناصر للصفحة الحالية
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTasks = state.TaskEvaluterAssigin?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // حساب عدد الصفحات
  const totalPages = Math.ceil(
    (state.TaskEvaluterAssigin?.length || 0) / itemsPerPage
  );

  // التحكم في تحديد الكل
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      // تحديد جميع المهام في الجدول بغض النظر عن الصفحة
      const allTasks = state.TaskEvaluterAssigin.map(
        (task) => task.taskFlowGUID
      );
      const allAppNumbers = state.TaskEvaluterAssigin.map(
        (task) => task.applicationNumber
      );
      settasksList(allTasks);
      setAppNumberList(allAppNumbers);
    } else {
      // إلغاء تحديد جميع المهام
      settasksList([]);
      setAppNumberList([]);
    }
  };

  const handleTaskSelection = (taskGUID, isChecked) => {
    if (isChecked) {
      settasksList([...tasksList, taskGUID]);
    } else {
      settasksList(tasksList.filter((guid) => guid !== taskGUID));
      setSelectAll(false); // إلغاء تحديد الكل إذا تم إلغاء تحديد أحد العناصر
    }
  };

  const handleTaskSelectionAddNumber = (appNumber, isChecked) => {
    if (isChecked) {
      setAppNumberList([...AppNumberList, appNumber]);
    } else {
      setAppNumberList(AppNumberList.filter((guid) => guid !== appNumber));
      setSelectAll(false); // إلغاء تحديد الكل إذا تم إلغاء تحديد أحد العناصر
    }
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const getListData = async () => {
    await dispatch(
      GetAccountUserAssigning({
        flowGUID: "6310803f-9c2e-4b7d-b8b8-35451a4ebc99",
        canMainTaskFlow: false,
      })
    );
    const data = await dispatch(GetAllTasksToEvalAssigin());
    if (data) {
      setloading(false);
    }
  };

  useEffect(() => {
    getListData();
  }, [state.refreshTableStatus]);

  console.log(tasksList, "tasksList", AppNumberList);
  const createTableHTML = (dataList) => {
    let tableHTML = `
      <table style="width: 100%; border-collapse: collapse; text-align: center;">
        <thead>
          <tr>
            <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;"></th>
            <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">رقم الطلب</th>
           
          </tr>
        </thead>
        <tbody>
    `;

    dataList.forEach((item, index) => {
      tableHTML += `
        <tr>
          <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
          <td style="border: 1px solid #ddd; padding: 8px;">${item}</td>
  
        </tr>
      `;
    });

    tableHTML += `
        </tbody>
      </table>
    `;

    return tableHTML;
  };

  const assiginingClicked = async () => {
    if (userList.length != 0 && tasksList.length != 0) {
      Swal.fire({
        title: `هل انت متأكد من تحويل الطلبات التالية للمحكم ( ${evalName} )`,
        icon: "info",
        html: createTableHTML(AppNumberList),
        draggable: true,
        confirmButtonText: "تأكيد",
        showConfirmButton: true,
        cancelButtonText: "الغاء",
        showCancelButton: true,
        showCloseButton: true,
        maxHeight: 200,
        customClass: {
          htmlContainer: "htmlContainerPopup",
        },
      }).then(async (res) => {
        // Callback triggered after user interacts with the popup.
        if (res.isConfirmed == true) {
          setloading(true);

          const success = await dispatch(
            CreateSubTaskeByFlowAndUser({
              taskGuidList: tasksList,
              uS_UserList: userList,
            })
          );
          if (success) {
            setAppNumberList([])
            settasksList([])
            setuserList([])
            handlePageChange(1);
            dispatch(setRefreshTable());

            setloading(false);
          }
        }
      });
    } else {
      Swal.fire({
        title:
          userList.length == 0
            ? "يجب اختيار المحكم"
            : "يجب تحديد طلب واحد على الاقل",
        icon: "warning",
        draggable: true,
        confirmButtonText: "خروج",
        showCloseButton: true,
      });
    }
  };
  return (
    <>
      {!state.loadingTaskEvaluterAssigin &&
      state.RoleByUserGuid?.includes("7382e598-e8b5-4077-aee6-cfdfd8b16e4f") ? (
        <SharedDiv
          showTitle={true}
          titleName="تحويل الى التحكيم"
          child={[
            <div className="containerrrrr">
              {/* <h2 style={styles.title}>قائمة المهام</h2> */}
              <label for={"SelectEval"} title={""}>
                اختيار محكم
                <span style={{ color: "red" }}> * </span>
                {/* {dataJsonObject[props.fieldsName]?.isRequired == "true" ? (
        ) : (
          ""
        )} */}
              </label>
              <AllDropDownsAHSF
                fieldsName="SelectEval"
                hidelable={true}
                labelName={"dddd"}
                show={true}
                disabled={false}
                arrayOoptionList={state.AccountUserAssigning}
                KeyText={"fullName"}
                id={"uS_UserGuid"}
                dropdownType={"search"}
                OnClickLi={(e) => {
                  console.log(e, "e.target");
                  setuserList([...userList, e.uS_UserGuid]);
                  setevalName(e.fullName);
                }}
                //   defaultValue={AdvertisingList.mP_MR_ItemId}
              />
              <table className="TasksTable">
                <thead>
                  <tr className="header">
                    <th>
                      <input
                        type="checkbox"
                        className="checkboxEval"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th> رقم الطلب</th>
                    <th>المهمة</th>
                    <th>حالة المهمة</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTasks &&
                    currentTasks.map((task, index) => (
                      <React.Fragment key={task.taskFlowGUID}>
                        {/* Main Task */}
                        <tr className="rowEval">
                          <td>
                            {/* <input
                              type="checkbox"
                              className="checkbox"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  settasksList([
                                    ...tasksList,
                                    task.taskFlowGUID,
                                  ]);
                                } else {
                                  settasksList(
                                    tasksList.filter(
                                      (elem, index) =>
                                        elem !== task.taskFlowGUID
                                    )
                                  );
                                }
                              }}
                            /> */}
                            <input
                              type="checkbox"
                              className="checkboxEval"
                              checked={tasksList.includes(task.taskFlowGUID)}
                              onChange={(e) => {
                                handleTaskSelection(
                                  task.taskFlowGUID,
                                  e.target.checked
                                );
                                handleTaskSelectionAddNumber(
                                  task.applicationNumber,
                                  e.target.checked
                                );
                              }}
                            />
                          </td>
                          <td>{task.applicationNumber}</td>
                          <td>{task.taskType}</td>
                          <td>{task.taskStatusName}</td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
              <div className="pagination-container">
                <div className="paginationR">
                  <div className="rows-per-page">
                    <select
                      id="rows-select"
                      value={itemsPerPage}
                      onChange={(e) => {
                        setitemsPerPage(Number(e.target.value));
                        handlePageChange(1);
                      }}
                      className="styled-select"
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                  </div>
                  {/* التحكم في عدد الصفوف الظاهرة */}

                  <div className="buttonsPage">
                    {/* أيقونة للذهاب لأول صفحة */}
                    <span
                      onClick={() => handlePageChange(1)}
                      className={`iconR ${currentPage === 1 ? "disabled" : ""}`}
                      title="الصفحة الأولى"
                    >
                      <i className="fas fa-angle-double-right"></i>
                    </span>

                    {/* أيقونة السابق */}
                    <span
                      onClick={() => handlePageChange(currentPage - 1)}
                      className={`iconR ${currentPage === 1 ? "disabled" : ""}`}
                      title="الصفحة السابقة"
                    >
                      <i className="fas fa-angle-right"></i>
                    </span>

                    {/* الصفحة الحالية */}
                    <span className="current-page">
                      صفحة {currentPage} من {totalPages}
                    </span>

                    {/* أيقونة التالي */}
                    <span
                      onClick={() => handlePageChange(currentPage + 1)}
                      className={`iconR ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                      title="الصفحة التالية"
                    >
                      <i className="fas fa-angle-left"></i>
                    </span>
                    {/* أيقونة للذهاب لآخر صفحة */}
                    <span
                      onClick={() => handlePageChange(totalPages)}
                      className={`iconR ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                      title="الصفحة الأخيرة"
                    >
                      <i className="fas fa-angle-double-left"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="containersButton" style={{ marginTop: "1%" }}>
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      assiginingClicked();
                    }}
                    disabled={false}
                    title={"تحويل الى التحكيم"}
                    text={"تحويل الى التحكيم"}
                    show={true}
                  />
                </div>
              </div>
            </div>,
          ]}
        />
      ) : (
        ""
      )}

      <LoaderAHSF show={loading} />
    </>
  );
};

export default AssiginToEvaluters;
